import {
  LOGIN_CONFIGURATION_DETAIL_ROUTE,
  LOGIN_CONFIGURATION_MASTER_ROUTE,
} from "config/route-consts";
import { ProtectedRoute } from "pages/Authentication/ProtectedRoute";
import React from "react";
import { Switch } from "react-router-dom";
import { authorizationService } from "services/common-services/authorization-service";
import LoginConfigurationDetail from "./LoginConfigurationDetail/LoginConfigurationDetail";
import LoginConfigurationMaster from "./LoginConfigurationMaster/LoginConfigurationMaster";

function LoginConfigurationView() {
  const { auth } = authorizationService.useAuthorizedRoute();
  return (
    <Switch>
      <ProtectedRoute
        path={LOGIN_CONFIGURATION_MASTER_ROUTE}
        key={LOGIN_CONFIGURATION_MASTER_ROUTE}
        component={LoginConfigurationMaster}
        auth={auth(LOGIN_CONFIGURATION_MASTER_ROUTE)}
      />
      <ProtectedRoute
        path={LOGIN_CONFIGURATION_DETAIL_ROUTE}
        key={LOGIN_CONFIGURATION_DETAIL_ROUTE}
        component={LoginConfigurationDetail}
        auth={auth(LOGIN_CONFIGURATION_DETAIL_ROUTE)}
      />
    </Switch>
  );
}

export { LoginConfigurationMaster };
export default LoginConfigurationView;
